import React from "react";

import PageError from "./PageError";

export interface NotFoundErrorProps {
  actionLabel?: string;
  onRetry?: () => void;
}

const NotFoundError: React.FC<NotFoundErrorProps> = ({
  actionLabel = "ホームへ",
  onRetry = () => {
    if (typeof window !== "undefined") {
      window.location.href = "/";
    }
  },
}) => {
  return (
    <PageError
      actionLabel={actionLabel}
      message="お探しのページは存在しないか、移動されました。"
      onRetry={onRetry}
      statusCode="404"
      title="ページが見つかりません"
    />
  );
};

export default NotFoundError;
